import styled from 'styled-components';

export const Title = styled.p`
  font-size: 15px;
  font-weight: bold;
  color: #000;
  margin: 0;
`;
export const Subtitle = styled.p`
  font-size: 15px;
  color: #000;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
`;
export const WrapperTitle = styled.div`
  padding: 10px 15px;
  background-color: #f2f2f2;
  margin: 0;
  color: #000;
  font-size: 18px;
  font-weight: bold;
  border: #ddd 1px solid;
  border-radius: 5px 5px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 15px;
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #ddd;

  ${Title} {
    margin-top: 20px;
  }
`;
export const WrapperField = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;

  label {
    font-size: 15px;
  }
`;
export const AdditionalEmailWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: center;

  .icon {
    cursor: pointer;
    margin-top: 15px;
  }
`;

export const Header = styled.div`
  background: ${props => props.theme.main.color};
  width: 100%;
  height: 100%;
  padding: 20px;

  ${Title} {
    font-size: 18px;
    color: #fff;
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;
